// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mu-2";
export var interactiveWrapper = "_mu-0";
export var shippingHoverPreview = "_mu-4";
export var summaryBadgeTrigger = "_mu-1";
export var widgetHoverPreviewList = "_mu-3";
export var widgetPreviewScale = "_mu-5";